export const surahs = [
  {
    id: 1,
    name: "Al-Fatiha",
    translation: "The Opening",
    verses: [
      { 
        text: "بِسْمِ اللَّهِ الرَّحْمَنِ الرَّحِيمِ", 
        transliteration: "Bismillah ir-Rahman ir-Raheem",
        translation: "In the Name of Allah—the Most Compassionate, Most Merciful."
      },
      { 
        text: "الْحَمْدُ لِلَّهِ رَبِّ الْعَالَمِينَ", 
        transliteration: "Alhamdu lillahi rabbil aalameen",
        translation: "All praise is for Allah—Lord of all worlds"
      },
      { 
        text: "الرَّحْمَنِ الرَّحِيمِ", 
        transliteration: "Ar-Rahman ir-Raheem",
        translation: "the Most Compassionate, Most Merciful,"
      },
      { 
        text: "مَالِكِ يَوْمِ الدِّينِ", 
        transliteration: "Maali ki yawmid deen",
        translation: "Master of the Day of Judgment."
      },
      { 
        text: "إِيَّاكَ نَعْبُدُ وَإِيَّاكَ نَسْتَعِينُ", 
        transliteration: "Iyyaaka na’budu wa iyyaaka nasta’een",
        translation: "You ˹alone˺ we worship and You ˹alone˺ we ask for help."
      },
      { 
        text: "اهْدِنَا الصِّرَاطَ الْمُسْتَقِيمَ", 
        transliteration: "Ihdina-as-siraatal-mustaqeem",
        translation: "Guide us along the Straight Path,"
      },
      { 
        text: "صِرَاطَ الَّذِينَ أَنْعَمْتَ عَلَيْهِمْ", 
        transliteration: "Siraatal-lazeena an’amta ‘alayhim",
        translation: "the Path of those You have blessed."
      },
      { 
        text: "غَيْرِ الْمَغْضُوبِ عَلَيْهِمْ وَالَا الضَّآلِّينَ", 
        transliteration: "Ghayril maghdoobi ‘alayhim wa laad daalleen",
        translation: "not those You are displeased with, or those who are astray"
      },
    ],
  },
  {
    id: 2,
    name: "Al-Nas",
    translation: "The People",
    verses: [
      { 
        text: "قُلْ أَعُوذُ بِرَبِّ النَّاسِ", 
        transliteration: "Qul a’udhu birabbin naas"
      },
      { 
        text: "مَلِكِ النَّاسِ", 
        transliteration: "Malikin naas"
      },
      { 
        text: "إِلَٰهِ النَّاسِ", 
        transliteration: "Ilaahin naas"
      },
      { 
        text: "مِنْ شَرِّ الْوَسْوَاسِ الْخَنَّاسِ", 
        transliteration: "Min sharri-l-waswaasi-l-khannaas"
      },
      { 
        text: "الَّذِي يُوَسْوِسُ فِي صُدُورِ النَّاسِ", 
        transliteration: "Alladhiyu waswisu fi sudoorin naas"
      },
      { 
        text: "مِنَ الْجِنَّةِ وَالنَّاسِ", 
        transliteration: "Mina-l-jinnati wan naas"
      },
    ],
  },
  {
    id: 3,
    name: "Al-Ikhlas",
    translation: "The Purity",
    verses: [
      { 
        text: "قُلْ هُوَ اللَّهُ أَحَدٌ", 
        transliteration: "Qul huwa Allahu Ahad"
      },
      { 
        text: "اللَّهُ الصَّمَدُ", 
        transliteration: "Allahu As-Samad"
      },
      { 
        text: "لَمْ يَلِدْ وَلَمْ يُولَدْ", 
        transliteration: "Lam yalid walam yoolad"
      },
      { 
        text: "وَلَمْ يَكُنْ لَهُۥۤ أَحَدٌۥۤ", 
        transliteration: "Walam yakun lahu ahad"
      },
    ],
  },
  {
    id: 4,
    name: "Al-Nasr",
    translation: "The Divine Support",
    verses: [
      { 
        text: "إِذَا جَآءَ نَصْرُ اللَّهِ وَالْفَتْحُ", 
        transliteration: "Iza jaa nasrullahi wal fath"
      },
      { 
        text: "وَرَأَيْتَ النَّاسَ يَدْخُلُونَ فِي دِينِ اللَّهِ أَفْوَاجًا", 
        transliteration: "Wa ra’ayta an-naasa yadkhuloona fee deenillahi afwajan"
      },
      { 
        text: "فَسَبِّحْ بِحَمْدِ رَبِّكَ وَاسْتَغْفِرْهُ إِنَّهُۥ كَانَ تَوَّابًا", 
        transliteration: "Fasabbih bihamdi rabbika wastaghfirhu innahu kana tawwaba"
      },
    ],
  },
  {
    id: 5,
    name: "Al-Fil",
    translation: "The Elephant",
    verses: [
      { 
        text: "أَلَمْ تَرَ كَيْفَ فَعَلَ رَبُّكَ بِأَصْحَابِ الْفِيلِ", 
        transliteration: "Alam tara kayfa fa’ala rabbuka bi ashaabil feel"
      },
      { 
        text: "أَلَمْ يَجْعَلْ كَيْدَهُمْ فِي تَضْلِيلٍ", 
        transliteration: "Alam yaj’al kaydahum fee tadleel"
      },
      { 
        text: "وَأَرْسَلَ عَلَيْهِمْ طَيْرًا أَبَابِيلَ", 
        transliteration: "Wa arsal ‘alayhim tayran ababeel"
      },
      { 
        text: "تَرْمِيهِمْ بِحِجَارَةٍ مِنْ سِجِّيلٍ", 
        transliteration: "Tarmihim bihijaaratin min sigeel"
      },
      { 
        text: "فَجَعَلَهُمْ كَعَصْفٍ مَّأْكُولٍ", 
        transliteration: "Faja’alahum ka’asfin ma’kool"
      },
    ],
  },
  {
    id: 6,
    name: "Al-Qua'ra",
    translation: "The Striking",
    verses: [
      { 
        text: "الْقَارِعَةُ", 
        transliteration: "Al-Qari’ah"
      },
      { 
        text: "مَا الْقَارِعَةُ", 
        transliteration: "Ma al-Qari’ah"
      },
      { 
        text: "وَمَا أَدْرَاكَ مَا الْقَارِعَةُ", 
        transliteration: "Wa ma adraka ma al-Qari’ah"
      },
      { 
        text: "يَوْمَ يَكُونُ النَّاسُ كَالفَرَاشِ الْمَبْثُوثِ", 
        transliteration: "Yawm yaqoonu an-naasu kafaraashi-l-mabthoot"
      },
      { 
        text: "وَتَكُونُ الْجِبَالُ كَالْعِهْنِ الْمَنفُوشِ", 
        transliteration: "Wa takoonu al-jibalu kalli’hni-l-manfoosh"
      },
    ],
  },
  {
    id: 7,
    name: "Al-Ma'un",
    translation: "The Small Kindnesses",
    verses: [
      { 
        text: "أَرَأَيْتَ الَّذِي يُكَذِّبُ بِالدِّينِ", 
        transliteration: "Ara’aita alladhiyu kazzibu bid-deen"
      },
      { 
        text: "فَذَٰلِكَ الَّذِي يَدُعُّ الْيَتِيمَ", 
        transliteration: "Fadhālika alladhiyu yadu’ul-yateem"
      },
      { 
        text: "وَلَا يَحُضُّ عَلَىٰ طَعَامِ الْمِسْكِينِ", 
        transliteration: "Wala yahuddu ‘ala ta’ami-l-miskeen"
      },
      { 
        text: "فَوَيْلٌ لِّلْمُصَلِّينَ", 
        transliteration: "Fawaylul limusalleen"
      },
      { 
        text: "الَّذِينَ هُمْ عَنْ صَلَاتِهِمْ سَاهُونَ", 
        transliteration: "Alladhina hum ‘an salaatihim saahoon"
      },
    ],
  },
  {
    id: 8,
    name: "Al-Alaq",
    translation: "The Clot",
    verses: [
      { 
        text: "اقْرَأْ بِاسْمِ رَبِّكَ الَّذِي خَلَقَ", 
        transliteration: "Iqra' bismi rabbika allathee khalaq"
      },
      { 
        text: "خَلَقَ الْإِنسَانَ مِنْ عَلَقٍ", 
        transliteration: "Khalaqal insana min 'alaq"
      },
      { 
        text: "اقْرَأْ وَرَبُّكَ الْأَكْرَمُ", 
        transliteration: "Iqra' wa rabbuka alakram"
      },
      { 
        text: "الَّذِي عَلَّمَ بِالْقَلَمِ", 
        transliteration: "Alladhiy 'allama bilqalam"
      },
      { 
        text: "عَلَّمَ الْإِنسَانَ مَا لَمْ يَعْلَمْ", 
        transliteration: "Allama al-insana ma lam ya'lam"
      },
    ],
  },
  {
    id: 9,
    name: "Al-Mulk",
    translation: "The Sovereignty",
    verses: [
      { 
        text: "تَبَارَكَ الَّذِي بِيَدِهِ الْمُلْكُ", 
        transliteration: "Tabarakalladhi biyadihi-l-mulk"
      },
      { 
        text: "وَهُوَ عَلَىٰ كُلِّ شَيْءٍ قَدِيرٌ", 
        transliteration: "Wahuwa 'ala kulli shay'in qadeer"
      },
      { 
        text: "الَّذِي خَلَقَ الْمَوْتَ وَالْحَيَاةَ", 
        transliteration: "Alladhikhalakalmawtawalhayaat"
      },
      { 
        text: "لِيَبْلُوَكُمْ أَيُّكُمْ أَحْسَنُ عَمَلًا", 
        transliteration: "Li-yablouwakum ayyukum ahsanu 'amala"
      },
      { 
        text: "وَهُوَ الْعَزِيزُ الْغَفُورُ", 
        transliteration: "Wahuwa al-azeezu al-ghafoor"
      },
    ],
  },
  {
    id: 10,
    name: "Al-Kawthar",
    translation: "The Abundance",
    verses: [
      { 
        text: "إِنَّا أَعْطَيْنَاكَ الْكَوْثَرَ", 
        transliteration: "Inna atainaka kawthar"
      },
      { 
        text: "فَصَلِّ لِرَبِّكَ وَانْحَرْ", 
        transliteration: "Fasalli li rabbika wanhar"
      },
      { 
        text: "إِنَّ شَانِئَكَ هُوَ الْأَبْتَرُ", 
        transliteration: "Inna shani'aka huwa al-abtar"
      },
    ],
  },
  {
    id: 11,
    name: "Al-Asr",
    translation: "The Time",
    verses: [
      { 
        text: "وَالْعَصْرِ", 
        transliteration: "Wal-Asr"
      },
      { 
        text: "إِنَّ الْإِنسَانَ لَفِي خُسْرٍ", 
        transliteration: "Inna al-insana lafee khusr"
      },
      { 
        text: "إِلَّا الَّذِينَ آمَنُوا وَعَمِلُوا الصَّالِحَاتِ", 
        transliteration: "Illa alladhina aamanu wa 'amilu assalihaat"
      },
      { 
        text: "وَتَوَاصَوْا بِالْحَقِّ", 
        transliteration: "Wa tawassaw bil-haqq"
      },
      { 
        text: "وَتَوَاصَوْا بِالصَّبْرِ", 
        transliteration: "Wa tawassaw bissabr"
      },
    ],
  },
  {
    id: 12,
    name: "Al-Bayyina",
    translation: "The Clear Proof",
    verses: [
      { 
        text: "لَمْ يَكُنِ الَّذِينَ كَفَرُوا مِنْ أَهْلِ الْكِتَابِ", 
        transliteration: "Lam yakuni alladhina kafaru min ahlil kitaabi"
      },
      { 
        text: "وَالْمُشْرِكِينَ مُنفَكِّينَ", 
        transliteration: "Wal mushrikeena munfakkeena"
      },
      { 
        text: "حَتَّى تَأْتِيَهُمُ الْبَيِّينَةُ", 
        transliteration: "Hatta ta'tiyahum al-bayyina"
      },
      { 
        text: "رَسُولٌۭ مِّنَ اللَّهِ", 
        transliteration: "Rasulun mina Allahi"
      },
      { 
        text: "يَتْلُوا۟ صُحُفًۭا مُّطَهَّرَةً", 
        transliteration: "Yatlu suhufan mutahharatan"
      },
    ],
  },
  {
    id: 13,
    name: "Al-Qadr",
    translation: "The Night of Decree",
    verses: [
      { 
        text: "إِنَّا أَنزَلْنَاهُ فِي لَيْلَةِ الْقَدْرِ", 
        transliteration: "Inna anzalnahu fee laylatil qadr"
      },
      { 
        text: "وَمَا أَدْرَاكَ مَا لَيْلَةُ الْقَدْرِ", 
        transliteration: "Wa ma adraka ma laylatul qadr"
      },
      { 
        text: "لَيْلَةُ الْقَدْرِ خَيْرٌ مِّنْ أَلْفِ شَهْرٍ", 
        transliteration: "Laylatul qadri khayrun min alfi shahr"
      },
      { 
        text: "تَنَزَّلُ الْمَلَائِكَةُ وَالرُّوحُ فِيهَا", 
        transliteration: "Tanzalul mala'ikatu war-roohu feeha"
      },
      { 
        text: "بِإِذْنِ رَبِّهِم مِّن كُلِّ أَمْرٍ", 
        transliteration: "Bi idhnir rabbihim min kulli amr"
      },
      { 
        text: "سَلاَمٌ هِيَ حَتَّىٰ مَطْلَعِ الْفَجْرِ", 
        transliteration: "Salaamun hiya hatta matla'il fajr"
      },
    ],
  },
  {
    id: 14,
    name: "Al-Takathur",
    translation: "The Rivalry in Worldly Increase",
    verses: [
      { 
        text: "أَلْهَاكُمُ التَّكَاثُرُ", 
        transliteration: "Alhakum ut-takathur"
      },
      { 
        text: "حَتَّىٰ زُرْتُمُ الْمَقَابِرَ", 
        transliteration: "Hatta zurtumul maqabeer"
      },
      { 
        text: "كَلَّا سَوْفَ تَعْلَمُونَ", 
        transliteration: "Kalla sawfa ta'lamoon"
      },
      { 
        text: "ثُمَّ كَلَّا سَوْفَ تَعْلَمُونَ", 
        transliteration: "Thumma kalla sawfa ta'lamoon"
      },
      { 
        text: "كَلَّا لَوْ تَعْلَمُونَ عِلْمَ الْيَقِينِ", 
        transliteration: "Kalla law ta'lamoon 'ilmal yaqeen"
      },
      { 
        text: "لَتَرَوُنَّ الْجَحِيمَ", 
        transliteration: "Latarawunnal jaheem"
      },
      { 
        text: "ثُمَّ لَتَرَوُنَّهَا عَيْنَ الْيَقِينِ", 
        transliteration: "Thumma latarawunnaha 'ayna al yaqeen"
      },
      { 
        text: "ثُمَّ لَتُسْأَلُنَّ يَوْمَئِذٍ عَنِ النَّعِيمِ", 
        transliteration: "Thumma latus'aloona yawm-idhin 'ani an-na'eem"
      },
    ],
  },
  {
    id: 15,
    name: "Al-Zalzalah",
    translation: "The Earthquake",
    verses: [
      { 
        text: "إِذَا زُلْزِلَتِ الْأَرْضُ زِلْزَالَهَا", 
        transliteration: "Iza zulzilatil ardu zilzalahaa"
      },
      { 
        text: "وَأَخْرَجَتِ الْأَرْضُ أَثْقَالَهَا", 
        transliteration: "Wa akhrajatil ardu athqaalahaa"
      },
      { 
        text: "وَقَالَ الْإِنسَانُ مَا لَهَا", 
        transliteration: "Wa qala al-insaanu ma lahaa"
      },
      { 
        text: "يَوْمَئِذٍ تُحَدِّثُ أَخْبَارَهَا", 
        transliteration: "Yawmayizhin tuhadithu akhbaarahaa"
      },
      { 
        text: "بِأَنَّ رَبَّكَ أَوْحَىٰ لَهَا", 
        transliteration: "Bi annna rabbaka awhaa lahaa"
      },
      { 
        text: "يَوْمَئِذٍ يَصْفُ النَّاسُ", 
        transliteration: "Yawmayizhin yasfoona naasu"
      },
    ],
  },
  {
    id: 16,
    name: "Al-Masad",
    translation: "The Palm Fiber",
    verses: [
      { 
        text: "تَبَّتْ يَدَا أَبِي لَهَبٍ وَتَبْ", 
        transliteration: "Tabbat yadaa abee lahabin watab"
      },
      { 
        text: "مَا أَغْنَىٰ عَنْهُ مَالُهُ وَمَا كَسَب", 
        transliteration: "Maa aghna 'anhu maaluhoo wama kasab"
      },
      { 
        text: "سَيَصْلَىٰ نَارًا ذَاتَ لَهَب", 
        transliteration: "Sayaslaa naaran dhaat al-lahab"
      },
      { 
        text: "وَمْرَأَتُهُ حَمَّالَةَ الْحَطَب", 
        transliteration: "Wamra’atuhu hamaalata al-hatab"
      },
      { 
        text: "فِي جِيدِهَا حَبْلٌ مِّن مَّسَد", 
        transliteration: "Fee jeedihaa hablun min masad"
      },
    ],
  },
  {
    id: 17,
    name: "Al-Naba",
    translation: "The Tidings",
    verses: [
      { 
        text: "عَمَّ يَتَسَاءَلُونَ", 
        transliteration: "Ammma yatasaa'aloona"
      },
      { 
        text: "عَنِ النَّبَإِ الْعَظِيمِ", 
        transliteration: "Anin nabee'il azeem"
      },
      { 
        text: "الَّذِي هُمْ فِيهِ مُخْتَلِفُونَ", 
        transliteration: "Alladhihu feehi mukhtalifoona"
      },
      { 
        text: "كَلا سَيَعْلَمُونَ", 
        transliteration: "Kalaa sa ya'lamoon"
      },
      { 
        text: "ثُمَّ كَلا سَيَعْلَمُونَ", 
        transliteration: "Thumma kalaa sa ya'lamoon"
      },
      { 
        text: "أَلَمْ نَجْعَلِ الْأَرْضَ مِهَادًا", 
        transliteration: "Alam naj'il arda mihaad"
      },
    ],
  },
  
  // Add more Surahs as needed.
];
